"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var apiService_1 = __importDefault(require("@common/services/apiService"));
var variableRef_1 = require("@/react-app/common/utils/blangEditor/variableRef");
var blangEditorUtil_1 = require("@/react-app/common/utils/blangEditor/blangEditorUtil");
var notifier_1 = __importDefault(require("@/react-app/common/utils/notifier"));
var Tooltip_1 = require("@/react-app/common/components/Tooltip");
var defaultContent = {
    text: '',
    price: 0,
    title: '',
    body: '',
    email: '',
    phoneNumber: '',
    categoryName: '',
    categoryId: '',
    currency: '',
    status: '',
    type: '',
    professional: '',
    userId: '',
    userName: '',
    city: '',
    postalCode: '',
    region: '',
    countryCode: '',
    ip: '',
};
function FilterTester(_a) {
    var _this = this;
    var _b, _c;
    var ruleVariables = _a.ruleVariables, isRuleExpressionValid = _a.isRuleExpressionValid, filter = _a.filter, domain = _a.domain, currentExpression = _a.currentExpression;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _d = __read((0, react_1.useState)(false), 2), isTestFilterLoading = _d[0], setIsTestFilterLoading = _d[1];
    var _e = __read((0, react_1.useState)(defaultContent), 2), content = _e[0], setContent = _e[1];
    var _f = __read((0, react_1.useState)([]), 2), testFields = _f[0], setTestFields = _f[1];
    var _g = __read((0, react_1.useState)(), 2), filterTester = _g[0], setFilterTester = _g[1];
    var expressionMatch = filterTester && filterTester.processingResults.length > 0;
    var wordsMatch = filterTester && ((_b = filterTester.processingResults[0]) === null || _b === void 0 ? void 0 : _b.blangResult.wordHighlighting.length) > 0;
    var wordsdHighlighting = filterTester && ((_c = filterTester.processingResults[0]) === null || _c === void 0 ? void 0 : _c.blangResult.wordHighlighting);
    var testFilterApiCall = function (newContent) { return __awaiter(_this, void 0, void 0, function () {
        var filterTestContentPayload, payload, response, newTestResult, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isRuleExpressionValid) {
                        return [2 /*return*/];
                    }
                    // To prevents sending "" to /filters/test api, because "" is considered existing variable EXIST("") -> Expression matches!
                    setIsTestFilterLoading(true);
                    filterTestContentPayload = Object.entries(newContent).reduce(function (acc, _a) {
                        var _b = __read(_a, 2), key = _b[0], value = _b[1];
                        acc[key] = typeof value === 'string' && value === '' ? '' : value;
                        return acc;
                    }, {});
                    payload = {
                        filter: filter,
                        content: [filterTestContentPayload],
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, apiService_1.default.testFilterRule({ domain: domain }, payload)];
                case 2:
                    response = _a.sent();
                    newTestResult = response.data[0];
                    setFilterTester(newTestResult);
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _a.sent();
                    notifier_1.default.error(t('AUTOMATION.DECISION_RULES.ERROR.ERROR_RUN_RULE'));
                    return [3 /*break*/, 5];
                case 4:
                    setIsTestFilterLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var onRuleChange = function () {
        if (!isRuleExpressionValid) {
            return;
        }
        if (ruleVariables) {
            var testFields_1 = (0, blangEditorUtil_1.getVariablesToTest)(ruleVariables, variableRef_1.VARIABLES_REF);
            setTestFields(testFields_1);
        }
    };
    var getNestedValue = function (ad, path) {
        try {
            return path.split('.').reduce(function (current, key) {
                if (current === null || current === undefined) {
                    // console.log(`Path ${path} resolved to undefined at key ${key}`);
                    return undefined;
                }
                // Handle array access with index
                var arrayMatch = key.match(/(\w+)\[(\d+)\]/);
                if (arrayMatch) {
                    var _a = __read(arrayMatch, 3), arrayKey = _a[1], index = _a[2];
                    var array = current[arrayKey];
                    if (!Array.isArray(array)) {
                        // console.log(`Expected array at ${arrayKey} but got ${typeof array}`);
                        return undefined;
                    }
                    return array[Number(index)];
                }
                return current[key];
            }, ad);
        }
        catch (error) {
            console.error("Error accessing path ".concat(path, ":"), error);
            return undefined;
        }
    };
    var getLastAdAsBlangContent = function (domain) { return __awaiter(_this, void 0, void 0, function () {
        var response, ad_1, newContent_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apiService_1.default.getLatestAd({ domain: domain })];
                case 1:
                    response = _a.sent();
                    ad_1 = response.data.ad[0];
                    newContent_1 = Object.entries(variableRef_1.VARIABLES_REF).reduce(function (acc, _a) {
                        var _b = __read(_a, 2), key = _b[0], item = _b[1];
                        var typedKey = key;
                        if (typeof item.adPath === 'string') {
                            // For text field, combine title and body
                            if (typedKey === 'text') {
                                var title = getNestedValue(ad_1, 'current.content.title') || '';
                                var body = getNestedValue(ad_1, 'current.content.body') || '';
                                acc[typedKey] = [title, body].filter(function (x) { return x; }).join(' ');
                            }
                            else {
                                // For other fields, get the value directly
                                var value = getNestedValue(ad_1, "current.".concat(item.adPath));
                                if (item.fieldType === 'boolean' && value === undefined) {
                                    acc[typedKey] = false;
                                }
                                acc[typedKey] = value;
                            }
                        }
                        else if (typeof item.adPath === 'function') {
                            acc[typedKey] = item.adPath(ad_1.current);
                        }
                        return acc;
                    }, {});
                    // console.log('new content react', newContent);
                    setContent(newContent_1);
                    setTimeout(function () { return testFilterApiCall(newContent_1); }, 400);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error('Error processing ad content:', error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        getLastAdAsBlangContent(domain);
    }, [domain]);
    (0, react_1.useEffect)(function () {
        onRuleChange();
    }, [ruleVariables, currentExpression]);
    var handleContentChange = function (field, value) {
        var _a;
        var titleValue = field === 'title' ? value : content.title;
        var bodyValue = field === 'body' ? value : content.body;
        var textValue = [titleValue, bodyValue].filter(function (x) { return x; }).join(' ');
        var newContent = __assign(__assign({}, content), (_a = {}, _a[field] = value, _a.text = textValue, _a));
        setContent(newContent);
        testFilterApiCall(newContent);
    };
    return (react_1.default.createElement("div", { className: "filter-tester" },
        react_1.default.createElement("div", { className: "header" },
            react_1.default.createElement("p", null, t('AUTOMATION.DECISION_RULES.RULE_BUILDER.RULE_TESTER.HEADER')),
            react_1.default.createElement("div", { className: "more-info" },
                react_1.default.createElement("span", { className: "tooltip-icon more-info-tooltip implioicons-question-mark-filled eva-tooltip-container--center" },
                    react_1.default.createElement(Tooltip_1.Tooltip, { className: "small-tooltip-style" }, t('AUTOMATION.DECISION_RULES.RULE_BUILDER.RULE_TESTER.HEADER_ICON_TOOLTIP'))))),
        react_1.default.createElement("div", { className: "filter-body" },
            content &&
                testFields.map(function (field, index) { return (react_1.default.createElement("div", { key: "".concat(field).concat(index), className: "form-group" },
                    variableRef_1.VARIABLES_REF[field].fieldType !== 'none' && react_1.default.createElement("label", null,
                        "$",
                        field,
                        ":"),
                    variableRef_1.VARIABLES_REF[field].fieldType === 'string' && (react_1.default.createElement("input", { type: "text", value: content[field], onChange: function (e) { return handleContentChange(field, e.target.value); } })),
                    variableRef_1.VARIABLES_REF[field].fieldType === 'integer' && (react_1.default.createElement("input", { type: "number", value: content[field], onChange: function (e) { return handleContentChange(field, e.target.value); } })),
                    variableRef_1.VARIABLES_REF[field].fieldType === 'text' && (react_1.default.createElement("textarea", { value: content[field], onChange: function (e) { return handleContentChange(field, e.target.value); } })),
                    variableRef_1.VARIABLES_REF[field].fieldType === 'boolean' && (react_1.default.createElement("input", { type: "checkbox", checked: content[field], onChange: function (e) { return handleContentChange(field, e.target.checked); } })))); }),
            isTestFilterLoading && react_1.default.createElement("p", { className: "bg-info" }, t('AUTOMATION.DECISION_RULES.RULE_BUILDER.RULE_TESTER.LOADING_TEXT')),
            !isRuleExpressionValid && (react_1.default.createElement("p", { className: "bg-default" }, t('AUTOMATION.DECISION_RULES.RULE_BUILDER.RULE_TESTER.VALID_EXPR_TEXT'))),
            filterTester && isRuleExpressionValid && (react_1.default.createElement("div", { className: "test-result" },
                expressionMatch && (react_1.default.createElement("p", { className: "bg-success" }, t('AUTOMATION.DECISION_RULES.RULE_BUILDER.RULE_TESTER.EXPR_MATCH_TEXT'))),
                !expressionMatch && (react_1.default.createElement("p", { className: "bg-warning" }, t('AUTOMATION.DECISION_RULES.RULE_BUILDER.RULE_TESTER.EXPR_NO_MATCH_TEXT'))),
                wordsMatch && react_1.default.createElement("h4", null, t('AUTOMATION.DECISION_RULES.RULE_BUILDER.RULE_TESTER.WORD_MATCH')),
                wordsMatch && wordsdHighlighting && (react_1.default.createElement("div", null, wordsdHighlighting === null || wordsdHighlighting === void 0 ? void 0 : wordsdHighlighting.map(function (item) { return (react_1.default.createElement("div", { key: item.variableName },
                    react_1.default.createElement("h5", null,
                        item.variableName,
                        ":"),
                    item.words.map(function (word) { return (react_1.default.createElement("span", { key: word.word, className: "label label-success" }, String(word.word))); }),
                    react_1.default.createElement("div", { style: { clear: 'both' } }))); }))),
                react_1.default.createElement("div", { style: { clear: 'both' } }))))));
}
exports.default = FilterTester;
